<template lang="pug">
transition(name="fade" mode="out-in")
  router-view
</template>

<script>
export default {
  name: 'CustomFields',
}
</script>

<style lang="stylus">
.top-line
  width 100%
  display flex
  justify-content space-between

h1
  display inline
</style>
